var map = {
	"./Add-icon.svg": 6598,
	"./Calendar-left-arrow.svg": 7198,
	"./Calendar-right-arrow.svg": 7036,
	"./Calendar.svg": 8535,
	"./Close-button.svg": 6250,
	"./Close-icon.svg": 7403,
	"./DUPS.svg": 5953,
	"./Dashboard.svg": 4537,
	"./Data.svg": 2683,
	"./DeleteUser.svg": 1959,
	"./Device-control.svg": 8298,
	"./DeviceLog.svg": 2221,
	"./DevicePower.svg": 6102,
	"./Document.svg": 7608,
	"./Down-arrow.svg": 8583,
	"./EditUser.svg": 3268,
	"./Error.svg": 2723,
	"./Excel.svg": 3705,
	"./FanIcon.svg": 2057,
	"./HomeIcon.svg": 7011,
	"./Notification.svg": 3953,
	"./PDF.svg": 5621,
	"./PaginationLeft.svg": 6003,
	"./PaginationRight.svg": 3175,
	"./Password-hide.svg": 1114,
	"./Password-show.svg": 3618,
	"./PdfIcon.svg": 6127,
	"./Plug.svg": 8318,
	"./Refresh.svg": 5573,
	"./Search.svg": 4716,
	"./SendCommand.svg": 4784,
	"./Setting.svg": 818,
	"./Stabilizer.svg": 6684,
	"./Switch.svg": 7168,
	"./Time-inteval-icon.svg": 8795,
	"./Toggle-arrow.svg": 9993,
	"./Trends.svg": 6318,
	"./WaterHeater.svg": 7386,
	"./addUser.svg": 294,
	"./alarmIcon.svg": 1401,
	"./deviceConnectivity.svg": 1247,
	"./downloadcsv.svg": 770,
	"./emptyData.svg": 3337,
	"./errorIcon.svg": 6793,
	"./exportGraphModal.svg": 7704,
	"./eyeIcon.svg": 2967,
	"./eyeInVisible.svg": 5680,
	"./eyeVisible.svg": 2160,
	"./info-button.svg": 7304,
	"./light_right.svg": 7257,
	"./refreshicon.svg": 6869,
	"./searchClickIcon.svg": 7453,
	"./userIcon.svg": 4,
	"./usermanagment.svg": 466,
	"./viewUser.svg": 4705
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4140;